import { render, staticRenderFns } from "./DoctorsList.vue?vue&type=template&id=a3416ce0&scoped=true&"
import script from "./DoctorsList.vue?vue&type=script&lang=js&"
export * from "./DoctorsList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsList.vue?vue&type=style&index=0&id=a3416ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3416ce0",
  null
  
)

export default component.exports